import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideoChatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"video_chat"}/>
}
